<template>
  <component :is="$route.meta.layout || 'div'">
    <v-app class="main-app">
      <router-view />
    </v-app>
  </component>
</template>

<script lang="ts" setup></script>
